<template>
  <div class="personal-file-page">
    <div class="personal-file__shell">
      <section class="hero-card">
        <div class="hero-card__left">
          <el-avatar class="hero-card__avatar" :size="48">{{ patientInitial }}</el-avatar>
          <div>
            <div class="hero-card__eyebrow">患者健康档案</div>
            <h2 class="hero-card__title">个人档案</h2>
          </div>
        </div>

        <div class="hero-card__info">
          <div class="info-item">
            <span class="info-item__label">姓名</span>
            <span class="info-item__value">{{ patientName }}</span>
          </div>
          <div class="info-item">
            <span class="info-item__label">性别</span>
            <span class="info-item__value">{{ patientGenderLabel }}</span>
          </div>
          <div class="info-item">
            <span class="info-item__label">联系方式</span>
            <span class="info-item__value">{{ form.phone || "--" }}</span>
          </div>
          <div class="info-item info-item--wide">
            <span class="info-item__label">现住址</span>
            <span class="info-item__value">{{ currentAddress }}</span>
          </div>
        </div>

        <div class="hero-card__tags">
          <el-tag size="small" effect="plain">档案编号：{{ (form?.healthNo) || "--" }}</el-tag>
          <el-tag size="small" effect="plain">登记号：{{ (form?.recordNo) || "--" }}</el-tag>
          <el-tag size="small" effect="plain" type="success">家庭成员：{{ familyCount }} 人</el-tag>
          <el-tag size="small" effect="plain" :type="form.isSmokeAlot === '是' ? 'warning' : 'info'">
            吸烟：{{ form.isSmokeAlot || "未填写" }}
          </el-tag>
          <el-tag size="small" effect="plain" :type="form.isDrinkAlot === '是' ? 'warning' : 'info'">
            饮酒：{{ form.isDrinkAlot || "未填写" }}
          </el-tag>
        </div>
      </section>

      <el-card shadow="never" class="section-card">
        <div slot="header" class="section-header">
          <div class="section-title-wrap">
            <img class="section-header__line" :src="linkLine" alt="" />
            <div>
              <div class="section-title">基本信息</div>
              <div class="section-desc">维护患者身份、联系方式与居住地址。</div>
            </div>
          </div>
        </div>

        <el-form class="file-form" label-position="top" :model="form">
          <div class="form-grid">
            <el-form-item label="姓名" class="field">
              <el-input v-model="form.name" clearable placeholder="请输入姓名"></el-input>
            </el-form-item>

            <el-form-item label="性别" class="field">
              <el-select v-model="form.gender" clearable filterable placeholder="请选择性别">
                <el-option v-for="item in sexOptions" :key="item.value" :label="item.name"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="身份证号" class="field field--wide">
              <el-input v-model="form.idcard" clearable placeholder="请输入身份证号"></el-input>
            </el-form-item>

            <el-form-item label="联系方式" class="field">
              <el-input v-model="form.phone" clearable placeholder="请输入联系方式"></el-input>
            </el-form-item>

            <el-form-item label="医疗费用支付方式" class="field">
              <el-select v-model="form.payWay" clearable filterable placeholder="请选择">
                <el-option v-for="item in paymentMethodData" :key="item.value" :label="item.name"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </div>

          <div class="sub-block">
            <div class="sub-block__title">现住址</div>
            <div class="address-grid">
              <el-form-item label="省" class="field">
                <el-select v-model="form.provinceCode" filterable placeholder="请选择省" @change="provinceCodeChange">
                  <el-option v-for="item in provinceData" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="市" class="field">
                <el-select v-model="form.cityCode" filterable placeholder="请选择市" @change="cityCodeChange">
                  <el-option v-for="item in cityData" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="区" class="field">
                <el-select v-model="form.countyCode" filterable placeholder="请选择区" @change="countyCodeChange">
                  <el-option v-for="item in countyData" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="乡镇（街道）" class="field">
                <el-select v-model="form.townCode" filterable clearable placeholder="请选择乡镇（街道）">
                  <el-option v-for="item in townData" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>

          <div class="sub-block">
            <div class="sub-block__title">生活方式</div>
            <div class="choice-grid">
              <el-form-item label="是否长期过量吸烟（吸烟≥20包年）" class="field">
                <el-radio-group v-model="form.isSmokeAlot" size="small">
                  <el-radio-button label="否">否</el-radio-button>
                  <el-radio-button label="是">是</el-radio-button>
                </el-radio-group>
              </el-form-item>

              <el-form-item label="是否长期过量饮酒（每日白酒≥100ml）" class="field">
                <el-radio-group v-model="form.isDrinkAlot" size="small">
                  <el-radio-button label="否">否</el-radio-button>
                  <el-radio-button label="是">是</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </el-card>

      <div class="multi-column-grid">
        <el-card shadow="never" class="section-card">
          <div slot="header" class="section-header">
            <div class="section-title-wrap">
              <img class="section-header__line" :src="linkLine" alt="" />
              <div>
                <div class="section-title">当前用药</div>
                <div class="section-desc">展示患者近期处方用药记录。</div>
              </div>
            </div>
            <div class="section-header__extra">
              <span class="drug-count-badge">共 {{ drugUsageTotal }} 条</span>
            </div>
          </div>

          <div class="drug-usage-list">
            <div v-if="drugUsageList.length" class="drug-list-scroll">
              <div v-for="(item, index) in drugUsageList" :key="'drug-' + index" class="drug-item">
                <div class="drug-item__name">
                  <i class="el-icon-medicine-box drug-item__icon"></i>
                  <span>{{ item.drugName }}</span>
                </div>
                <div class="drug-item__meta">
                  <span class="drug-meta-item">
                    <i class="el-icon-s-operation"></i>
                    {{ item.dose || "--" }}
                  </span>
                  <span class="drug-meta-item">
                    <i class="el-icon-time"></i>
                    {{ item.freqName || "--" }}
                  </span>
                  <span class="drug-meta-item">
                    <i class="el-icon-office-building"></i>
                    {{ item.hospitalName || "--" }}
                  </span>
                </div>
                <div class="drug-item__time">
                  <i class="el-icon-date"></i>
                  {{ item.prescribeTime ? formatDate(item.prescribeTime) : "--" }}
                </div>
              </div>
            </div>
            <div v-else class="drug-empty">
              <i class="el-icon-document-remove"></i>
              <span>暂无用药记录</span>
            </div>
          </div>
        </el-card>

        <el-card shadow="never" class="section-card">
          <div slot="header" class="section-header">
            <div class="section-title-wrap">
              <img class="section-header__line" :src="linkLine" alt="" />
              <div>
                <div class="section-title">近期检测</div>
                <div class="section-desc">患者近期血糖等检测数据记录。</div>
              </div>
            </div>
            <div class="section-header__extra">
              <span class="drug-count-badge">共 {{ bloodSugarTotal }} 条</span>
            </div>
          </div>

          <div class="blood-sugar-list">
            <div v-if="bloodSugarList.length" class="blood-sugar-scroll">
              <div v-for="(item, index) in bloodSugarList" :key="'sugar-' + index" class="blood-sugar-item">
                <div class="blood-sugar-item__left">
                  <span class="blood-sugar-label">{{ item.measureStatus || "--" }}:</span>
                  <span class="blood-sugar-value">{{ item.bloodSugar || "--" }}</span>
                </div>
                <div class="blood-sugar-item__time">
                  <i class="el-icon-date"></i>
                  {{ item.time || "--" }}
                </div>
              </div>
            </div>
            <div v-else class="drug-empty">
              <i class="el-icon-document-remove"></i>
              <span>暂无检测记录</span>
            </div>
          </div>
        </el-card>

        <el-card shadow="never" class="section-card">
          <div slot="header" class="section-header">
            <div class="section-title-wrap">
              <img class="section-header__line" :src="linkLine" alt="" />
              <div>
                <div class="section-title">近期检验检查</div>
                <div class="section-desc">患者近期检验和检查报告记录。</div>
              </div>
            </div>
            <div class="section-header__extra">
              <el-radio-group v-model="labExamType" size="mini" @change="labExamTypeChange">
                <el-radio-button label="检验"></el-radio-button>
                <el-radio-button label="检查"></el-radio-button>
              </el-radio-group>
            </div>
          </div>

          <div class="lab-exam-list">
            <div v-if="labExamData.length" class="lab-exam-scroll">
              <div v-for="(item, index) in labExamData" :key="'labexam-' + index" class="lab-exam-item">
                <div class="lab-exam-item__left">
                  <div class="lab-exam-type-tag" :class="labExamType === '检验' ? 'tag-lab' : 'tag-exam'">
                    {{ labExamType }}
                  </div>
                  <span class="lab-exam-name">{{ getTestItemName(item) }}</span>
                </div>
                <div class="lab-exam-item__right">
                  <span class="lab-exam-time">{{ getParsedTime(item) }}</span>
                  <el-button size="mini" type="text" @click="viewLabExamDetail(item)">
                    查看
                  </el-button>
                </div>
              </div>
            </div>
            <div v-else class="drug-empty">
              <i class="el-icon-document-remove"></i>
              <span>暂无{{ labExamType }}报告记录</span>
            </div>
          </div>
        </el-card>
      </div>

      <lab-detail
        v-if="labReportDetailVisible"
        ref="LabReportDetailRef"
      ></lab-detail>

      <exam-detail
        v-if="examReportDetailVisible"
        ref="ExamReportDetailRef"
      ></exam-detail>

      <el-card shadow="never" class="section-card">
        <div slot="header" class="section-header">
          <div class="section-title-wrap">
            <img class="section-header__line" :src="linkLine" alt="" />
            <div>
              <div class="section-title">既往病史</div>
              <div class="section-desc">记录过敏信息、疾病史与家族史。</div>
            </div>
          </div>
        </div>


        <div class="history-grid">
          <div class="history-card history-card--wide history-card--accent">
            <div class="history-card__header">
              <div>
                <div class="history-card__title">药物过敏史</div>
                <div class="history-card__desc">支持多选，“无”将与其他选项互斥。</div>
              </div>
              <span class="history-card__badge">多选</span>
            </div>

            <el-form class="file-form" size="small" label-position="top" :model="form">
              <el-form-item class="field field--no-margin">
                <el-checkbox-group v-model="allergyDrugArr" class="checkbox-wrap" @change="allergyDataChange">
                  <el-checkbox v-for="item in allergyData" :key="item.value" :label="item.value">
                    {{ item.name }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-form>
          </div>

          <div class="history-card">
            <div class="history-card__header history-card__header--start">
              <div>
                <div class="history-card__title">疾病史</div>
                <div class="history-card__desc">必填项，若无疾病史，疾病名称请选择“无”。</div>
              </div>
              <el-button type="primary" plain class="history-card__action" @click="addDiseasesItem()">
                新增
              </el-button>
            </div>

            <div v-if="diseases.length" class="history-list">
              <div class="history-table-head">
                <span class="history-table-head__cell">疾病名称</span>
                <span class="history-table-head__cell">确诊时间</span>
                <span class="history-table-head__cell history-table-head__cell--action"></span>
              </div>
              <div v-for="(item, index) in diseases" :key="'disease-' + index" class="history-entry">
                <el-form class="file-form history-entry__form" size="small">
                  <el-form-item class="history-entry__field">
                    <el-select v-model="item.diseaseCode" placeholder="疾病名称">
                      <el-option v-for="(option, diseaseIndex) in diseasesData" :key="option.value" :label="option.name"
                        :value="option.value"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item class="history-entry__field">
                    <el-date-picker v-model="item.diseaseTime" placeholder="请选择日期"
                      value-format="yyyy-MM-dd"></el-date-picker>
                  </el-form-item>
                  <el-form-item class="history-entry__field history-entry__field--action">
                    <el-button type="danger" plain class="history-entry__remove" @click="deleteDiseasesItem(index)">
                      删除
                    </el-button>
                  </el-form-item>
                </el-form>
              </div>
            </div>
            <div v-else class="history-empty">暂无疾病史记录，点击右上角新增。</div>
          </div>

          <div class="history-card">
            <div class="history-card__header history-card__header--start">
              <div>
                <div class="history-card__title">家族史</div>
                <div class="history-card__desc">必填项，若无家族史，疾病名称请选择“无”。</div>
              </div>
              <el-button type="primary" plain class="history-card__action" @click="addFamilyHistoryItem()">
                新增
              </el-button>
            </div>

            <div v-if="familyHistory.length" class="history-list">
              <div class="history-table-head">
                <span class="history-table-head__cell">疾病名称</span>
                <span class="history-table-head__cell">家族关系</span>
                <span class="history-table-head__cell history-table-head__cell--action"></span>
              </div>
              <div v-for="(item, index) in familyHistory" :key="'family-history-' + index" class="history-entry">
                <el-form class="file-form history-entry__form" size="small">
                  <el-form-item class="history-entry__field">
                    <el-select v-model="item.diseaseCode" placeholder="疾病名称">
                      <el-option v-for="(option, diseaseIndex) in diseasesData" :key="option.value" :label="option.name"
                        :value="option.value"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item class="history-entry__field">
                    <el-select v-model="item.familyRelationCode" placeholder="关系">
                      <el-option v-for="(relation, relationIndex) in familyRelationData" :key="relation.value"
                        :label="relation.name" :value="relation.value"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item class="history-entry__field history-entry__field--action">
                    <el-button type="danger" plain class="history-entry__remove"
                      @click="deleteFamilyHistoryItem(index)">
                      删除
                    </el-button>
                  </el-form-item>
                </el-form>
              </div>
            </div>
            <div v-else class="history-empty">暂无家族史记录，点击右上角新增。</div>
          </div>
        </div>
      </el-card>

      <el-card shadow="never" class="section-card">
        <div slot="header" class="section-header">
          <div class="section-title-wrap">
            <img class="section-header__line" :src="linkLine" alt="" />
            <div>
              <div class="section-title">家庭成员</div>
              <div class="section-desc">维护与当前患者关联的家庭成员信息。</div>
            </div>
          </div>

          <div class="section-header__extra">
            <span class="member-count-badge">共 {{ familyCount }} 人</span>
            <el-button type="primary" plain icon="el-icon-plus" @click="handleNewAdd">新增成员</el-button>
          </div>
        </div>

        <div class="table-card__summary">
          <span>家庭成员列表支持分页浏览、编辑和删除。</span>
          <span>如需补充联系人信息，可直接从右上角新增。</span>
        </div>

        <div class="table-scroll">
          <el-table v-loading="listLoading" :data="familyMembers" row-key="id" border stripe fit highlight-current-row
            class="member-table" empty-text="暂无家庭成员，点击右上角新增成员开始维护。">
            <el-table-column align="left" label="成员姓名" min-width="180">
              <template slot-scope="scope">
                <div class="member-name-cell">
                  <el-avatar class="member-avatar" :size="34">
                    {{ scope.row.name ? scope.row.name.slice(0, 1) : "人" }}
                  </el-avatar>
                  <span>{{ scope.row.name || "--" }}</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column align="center" prop="idcard" label="身份证号" min-width="200"></el-table-column>
            <el-table-column align="center" prop="phone" label="联系电话" min-width="140"></el-table-column>

            <el-table-column align="center" label="与本人关系" min-width="140">
              <template slot-scope="scope">
                <el-tag size="small" effect="plain" class="relation-tag">
                  {{ scope.row.relationName || "--" }}
                </el-tag>
              </template>
            </el-table-column>

            <el-table-column align="center" label="操作" width="180" fixed="right">
              <template slot-scope="scope">
                <el-button type="text" @click="handleEditFamilyMember(scope.row)">编辑</el-button>
                <el-popconfirm title="是否确认删除？" @confirm="handleDeleteFamilyMember(scope.row)">
                  <el-button slot="reference" type="text" class="danger-text">删除</el-button>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <pagination v-show="total > 0" class="pagination-bar" :total="total" :page.sync="formData.pageNum"
          :limit.sync="formData.pageSize" @pagination="turnToPage" />
      </el-card>

      <div class="action-bar">
        <div class="action-bar__hint">
          <i class="el-icon-document"></i>
          <span>当前页面用于维护患者档案信息与家庭成员关系。</span>
        </div>
        <el-button type="primary" size="medium" @click="handleSubmit">保存</el-button>
      </div>
    </div>

    <el-dialog :title="memberDialogTitle" :visible.sync="open" append-to-body class="member-dialog" width="680px"
      top="18vh" @closed="resetMemberDialog">
      <div class="member-dialog__tip">
        <i class="el-icon-user-solid"></i>
        <div>
          <div class="member-dialog__tip-title">{{ isUpdate ? "编辑成员信息" : "新增家庭成员信息" }}</div>
          <div class="member-dialog__tip-desc">请填写真实姓名、证件号与联系方式，便于家庭健康档案管理。</div>
        </div>
      </div>

      <el-form ref="modelForm" label-position="top" :model="model" :rules="rules" class="member-form">
        <div class="member-form__grid">
          <el-form-item label="成员姓名" prop="name" class="field">
            <el-input v-model="model.name" clearable placeholder="请输入成员姓名">
              <i slot="prefix" class="el-input__icon el-icon-user"></i>
            </el-input>
          </el-form-item>

          <el-form-item label="身份证号" prop="idcard" class="field">
            <el-input v-model="model.idcard" clearable placeholder="请输入身份证号">
              <i slot="prefix" class="el-input__icon el-icon-postcard"></i>
            </el-input>
          </el-form-item>

          <el-form-item label="联系电话" prop="phone" class="field">
            <el-input v-model="model.phone" clearable placeholder="请输入联系电话">
              <i slot="prefix" class="el-input__icon el-icon-mobile-phone"></i>
            </el-input>
          </el-form-item>

          <el-form-item label="与本人关系" prop="relationCode" class="field">
            <el-select v-model="model.relationCode" clearable filterable placeholder="请选择">
              <el-option v-for="item in familyRelationData" :key="item.value" :label="item.name"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>

      <span slot="footer" class="member-dialog__footer">
        <span class="member-dialog__footer-hint">
          <i class="el-icon-info"></i>
          提交后将同步更新家庭成员列表
        </span>
        <span>
          <el-button @click="open = false">取消</el-button>
          <el-button type="primary" @click="handleModelSubmit">
            {{ isUpdate ? "保存修改" : "确定添加" }}
          </el-button>
        </span>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import imageLine from "@/assets/images/titleLine.png";
import { postAreaList } from "@/api/health/Lung";
import {
  getSysDicList,
  getContactList,
  addContactList,
  updateContactList,
  turnToContactList,
  delContactList,
  updatePatientList,
  getSearchList,
  getBloodSugarList
} from "@/api/health/Patients";
import { getPatientDrugUsage } from "@/api/health/VisitQuery";
import { getLabInfos } from "@/api/health/LabQuery";
import { getExamReportInfos } from "@/api/health/ExamReportQuery";
import labDetail from "@/views/patient/info/diseaseInfo/labAndExam/labDetail.vue";
import examDetail from "@/views/patient/info/diseaseInfo/labAndExam/examDetail.vue";
import pagination from "@/components/Pagination";

export default {
  components: { pagination, labDetail, examDetail },
  props: {
    pInfo: null
  },
  data() {
    return {
      open: false,
      linkLine: imageLine,
      listLoading: false,
      isUpdate: false,
      form: {
        name: "",
        gender: "",
        idcard: "",
        phone: "",
        payWay: "",
        recordNo: null,
        provinceCode: null,
        cityCode: null,
        countyCode: null,
        townCode: null,
        isSmokeAlot: "否",
        isDrinkAlot: "否",
        diseaseCode: null,
        diseaseTime: null,
        familyDiseaseCode: null,
        familyRelationCode: null,
        diseases: [],
        familyHistory: [],
      },
      //疾病史
      diseases: [{
        diseaseCode: null,
        diseaseName: null,
        diseaseTime: null
      }],
      //家族史
      familyHistory: [{
        diseaseCode: null,
        diseaseName: null,
        diseaseTime: null,
        familyRelationCode: null,
        familyRelationName: null
      }],
      formData: {
        pageNum: 1,
        pageSize: 10
      },
      model: {
        name: "",
        idcard: "",
        phone: "",
        relationCode: ""
      },
      total: 0,
      sexOptions: [],
      paymentMethodData: [],
      provinceData: [],
      cityData: [],
      countyData: [],
      townData: [],
      diseasesData: [],
      familyRelationData: [],
      allergyData: [],
      allergyDrugArr: ["1"],
      familyMembers: [],
      drugUsageList: [],
      drugUsageTotal: 0,
      bloodSugarList: [],
      bloodSugarTotal: 0,
      labExamType: "检验",
      labDataList: [],
      examDataList: [],
      labExamData: [],
      labReportDetailVisible: false,
      examReportDetailVisible: false,
      rules: {
        name: [{ required: true, message: "请输入", trigger: "blur" }],
        idcard: [{ required: true, message: "请输入", trigger: "blur" }],
        phone: [{ required: true, message: "请输入", trigger: "blur" }],
        relationCode: [{ required: true, message: "请选择", trigger: "change" }]
      }
    };
  },
  computed: {
    patientName() {
      return this.form.name || this.pInfo?.patientName || this.pInfo?.name || "未填写";
    },
    patientInitial() {
      const initial = String(this.patientName || "").trim().slice(0, 1);
      return initial || "档";
    },
    patientGenderLabel() {
      return this.getGender(this.form.gender) || "未填写";
    },
    currentAddress() {
      const parts = [
        this.getOptionLabel(this.provinceData, this.form.provinceCode),
        this.getOptionLabel(this.cityData, this.form.cityCode),
        this.getOptionLabel(this.countyData, this.form.countyCode),
        this.getOptionLabel(this.townData, this.form.townCode)
      ].filter(Boolean);
      return parts.length ? parts.join(" / ") : "未填写";
    },
    familyCount() {
      return this.total || this.familyMembers.length || 0;
    },
    memberDialogTitle() {
      return this.isUpdate ? "编辑家庭成员" : "新增家庭成员";
    }
  },
  created() {
    this.initData(this.pInfo);
  },
  methods: {
    addDiseasesItem() {
      this.diseases.push({
        diseaseCode: null,
        diseaseName: null,
        diseaseTime: null
      });
    },
    deleteDiseasesItem(index) {
      this.diseases.splice(index, 1);
    },
    addFamilyHistoryItem() {
      this.familyHistory.push({
        diseaseCode: null,
        diseaseName: null,
        diseaseTime: null,
        familyRelationCode: null,
        familyRelationName: null
      });
    },
    deleteFamilyHistoryItem(index) {
      this.familyHistory.splice(index, 1);
    },
    createEmptyMember() {
      return {
        name: "",
        idcard: "",
        phone: "",
        relationCode: ""
      };
    },
    async initData(row = {}) {
      const loading = this.$loading({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(15, 23, 42, 0.16)"
      });
      try {
        const res = await getSearchList({ idcard: row.idcard })
        const item = res.data.records?.find(x => x.idcard === row.idcard) || {};
        this.form.id = row?.id || '';
        this.form.healthNo = item?.healthNo ? item?.healthNo : null;
        this.form.name = item?.patientName || item?.name || "";
        this.form.recordNo = item?.recordNo || null;
        this.form.gender = item?.gender || "";
        this.form.idcard = item?.idcard || "";
        this.form.phone = item?.phone || item?.contactPhone || "";
        this.form.payWay = item?.payWay || "";
        this.form.provinceCode = item?.provinceCode || null;
        this.form.cityCode = item?.cityCode || null;
        this.form.countyCode = item?.countyCode || null;
        this.form.townCode = item?.townCode || null;
        this.form.isSmokeAlot = item?.isSmokeAlot || "否";
        this.form.isDrinkAlot = item?.isDrinkAlot || "否";
        this.allergyDrugArr = item?.allergyDrug ? item.allergyDrug.split(',') : [];
        this.allergyDrugArr = ['2', '3']
        this.form.allergyDrug = item?.allergyDrug ? item?.allergyDrug : '';
        this.diseases = item?.diseases ? item?.diseases : [{
          diseaseCode: null,
          diseaseName: null,
          diseaseTime: null
        }];
        this.familyHistory = item?.familyHistory ? item?.familyHistory : [{
          diseaseCode: null,
          diseaseName: null,
          diseaseTime: null,
          familyRelationCode: null,
          familyRelationName: null
        }];
        // console.warn("form: ", this.form, this.diseases, this.familyHistory);
        await this.getSystemDictList("性别,医疗费用来源类别代码表,既往常见疾病种类代码表,家庭关系代码,公卫药物过敏史");
        await Promise.all([this.getList(), this.getProvinceData(), this.getDrugUsageList(), this.getBloodSugarList(), this.getLabList(), this.getExamList()]);
      } catch (e) { console.warn(e) }
      finally {
        loading.close();
      }
    },
    async getList() {
      if (!this.pInfo?.idcard) {
        this.familyMembers = [];
        this.total = 0;
        return;
      }

      this.formData.householderIdcard = this.pInfo.idcard;
      this.listLoading = true;

      try {
        const res = await getContactList(this.formData);
        if (res.msg === "success") {
          this.familyMembers = res?.data?.records || [];
          this.total = res?.data?.total || 0;
        }
      } finally {
        this.listLoading = false;
      }
    },
    async getDrugUsageList() {
      if (!this.pInfo?.idcard) {
        this.drugUsageList = [];
        this.drugUsageTotal = 0;
        return;
      }

      try {
        const params = {
          idcard: this.pInfo.idcard,
          startTime: null,
          endTime: null,
          pageNum: 1,
          pageSize: 20
        };
        const res = await getPatientDrugUsage(params);
        if (res) {
          this.drugUsageList = res?.contents || [];
          this.drugUsageTotal = res?.totalRecords || 0;
        }
      } catch (err) {
        console.warn(err);
      }
    },
    async getBloodSugarList() {
      if (!this.pInfo?.idcard) {
        this.bloodSugarList = [];
        this.bloodSugarTotal = 0;
        return;
      }

      try {
        const params = {
          idcard: this.pInfo.idcard,
          startTime: null,
          endTime: null,
          pageNum: 1,
          pageSize: 20
        };
        const res = await getBloodSugarList(params);
        if (res && res.data) {
          this.bloodSugarList = res?.data?.records || [];
          this.bloodSugarTotal = res?.data?.records?.length || 0;
        }
      } catch (err) {
        console.warn(err);
      }
    },
    async getLabList() {
      if (!this.pInfo?.idcard) {
        this.labDataList = [];
        return;
      }

      try {
        const params = {
          idcard: this.pInfo.idcard,
          queryDetail: 1
        };
        const res = await getLabInfos(params);
        if (res) {
          this.labDataList = res?.contents || [];
          if (this.labExamType === "检验") {
            this.labExamData = this.labDataList;
          }
        }
      } catch (err) {
        console.warn(err);
      }
    },
    async getExamList() {
      if (!this.pInfo?.idcard) {
        this.examDataList = [];
        return;
      }

      try {
        const params = {
          idcard: this.pInfo.idcard,
          queryDetail: 1
        };
        const res = await getExamReportInfos(params);
        if (res) {
          this.examDataList = res?.contents || [];
          if (this.labExamType === "检查") {
            this.labExamData = this.examDataList;
          }
        }
      } catch (err) {
        console.warn(err);
      }
    },
    labExamTypeChange(type) {
      if (type === "检验") {
        this.labExamType = "检验";
        this.labExamData = this.labDataList;
      } else {
        this.labExamType = "检查";
        this.labExamData = this.examDataList;
      }
    },
    getTestItemName(row) {
      let testItemStr = "";
      if (this.labExamType === "检验") {
        testItemStr = row.name || "";
      } else {
        testItemStr = row.reportName || "";
      }
      return testItemStr;
    },
    getParsedTime(row) {
      return row.reportTime || row.createTime || "--";
    },
    viewLabExamDetail(row) {
      if (this.labExamType === "检验") {
        this.labReportDetailVisible = true;
        this.$nextTick(() => {
          this.$refs.LabReportDetailRef.init(row);
        });
      } else {
        this.examReportDetailVisible = true;
        this.$nextTick(() => {
          this.$refs.ExamReportDetailRef.init(row);
        });
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return "--";
      const date = new Date(dateStr);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
    async turnToPage() {
      if (!this.pInfo?.idcard) {
        this.familyMembers = [];
        this.total = 0;
        return;
      }

      this.formData.householderIdcard = this.pInfo.idcard;
      this.listLoading = true;

      try {
        const res = await turnToContactList(this.formData);
        if (res.msg === "success") {
          this.familyMembers = res?.data?.records || [];
          this.total = res?.data?.total || 0;
        }
      } finally {
        this.listLoading = false;
      }
    },
    getGender(gender) {
      const option = this.sexOptions.find(item => String(item.value) === String(gender));
      return option?.name || "";
    },
    getRelation(code) {
      const option = this.familyRelationData.find(item => String(item.value) === String(code));
      return option?.name || "";
    },
    getOptionLabel(list, value) {
      const option = list.find(item => String(item.value) === String(value));
      return option?.label || option?.name || "";
    },
    async getSystemDictList(typeName) {
      const typeData = { typeName };

      try {
        const res = await getSysDicList(typeData);
        const records = res.msg === "success" ? res?.data?.records || [] : [];

        this.sexOptions = records.filter(item => item.typeName === "性别");
        this.paymentMethodData = records.filter(item => item.typeName === "医疗费用来源类别代码表");
        this.diseasesData = records.filter(item => item.typeName === "既往常见疾病种类代码表");
        this.allergyData = records.filter(item => item.typeName === "公卫药物过敏史");
        this.familyRelationData = records.filter(item => item.typeName === "家庭关系代码");
      } catch (err) {
        console.log(err);
      }
    },
    async getProvinceData() {
      try {
        const res = await postAreaList({ level: 1, page: 1, pageSize: 100 });
        if (res.msg !== "success") return;

        this.provinceData = (res?.data?.records || []).map(item => ({
          value: item.code,
          label: item.name
        }));

        this.form.provinceCode = this.form.provinceCode || 370000000000;
        await this.getAreaData(this.form.provinceCode, "city");

        this.form.cityCode = this.form.cityCode || 370200000000;
        await this.getAreaData(this.form.cityCode, "county");

        this.form.countyCode = this.form.countyCode || 370211000000;
        await this.getAreaData(this.form.countyCode, "town");
      } catch (err) {
        console.log(err);
      }
    },
    allergyDataChange(value) {
      const lastValue = value[value.length - 1];
      if (lastValue === "1") {
        this.allergyDrugArr = ["1"];
        return;
      }

      if (this.allergyDrugArr.includes("1")) {
        this.allergyDrugArr = this.allergyDrugArr.filter(item => item !== "1");
      }
    },
    async getAreaData(parentcode, type) {
      if (!parentcode) {
        if (type === "city") this.cityData = [];
        if (type === "county") this.countyData = [];
        if (type === "town") this.townData = [];
        return;
      }

      try {
        const res = await postAreaList({ pcode: parentcode });
        if (res.msg !== "success") return;

        const list = (res?.data?.records || []).map(item => ({
          value: item.code,
          label: item.name
        }));

        if (type === "city") this.cityData = list;
        if (type === "county") this.countyData = list;
        if (type === "town") this.townData = list;
      } catch (err) {
        console.log(err);
      }
    },
    async provinceCodeChange(value) {
      this.form.cityCode = null;
      this.form.countyCode = null;
      this.form.townCode = null;
      this.cityData = [];
      this.countyData = [];
      this.townData = [];
      await this.getAreaData(value, "city");
    },
    async cityCodeChange(value) {
      this.form.countyCode = null;
      this.form.townCode = null;
      this.countyData = [];
      this.townData = [];
      await this.getAreaData(value, "county");
    },
    async countyCodeChange(value) {
      this.form.townCode = null;
      this.townData = [];
      await this.getAreaData(value, "town");
    },
    async handleModelSubmit() {
      try {
        await this.$refs.modelForm.validate();

        const params = {
          idcard: this.model.idcard,
          name: this.model.name,
          phone: this.model.phone,
          relationCode: this.model.relationCode,
          relationName: this.getRelation(this.model.relationCode),
          householderIdcard: this.pInfo?.idcard
        };

        if (!this.isUpdate) {
          await addContactList(params);
        } else {
          await updateContactList({ id: this.model?.id, ...params });
        }

        await this.getList();
        this.$message.success(this.isUpdate ? "更新成功" : "新增成功");
        this.open = false;
      } catch (err) {
        console.warn(err);
      }
    },
    resetMemberDialog() {
      this.isUpdate = false;
      this.model = this.createEmptyMember();
      this.$nextTick(() => {
        if (this.$refs.modelForm) {
          this.$refs.modelForm.clearValidate();
        }
      });
    },
    handleNewAdd() {
      this.isUpdate = false;
      this.model = this.createEmptyMember();
      this.open = true;
      this.$nextTick(() => {
        if (this.$refs.modelForm) {
          this.$refs.modelForm.clearValidate();
        }
      });
    },
    handleEditFamilyMember(row) {
      this.isUpdate = true;
      this.model = { ...this.createEmptyMember(), ...row };
      this.open = true;
      this.$nextTick(() => {
        if (this.$refs.modelForm) {
          this.$refs.modelForm.clearValidate();
        }
      });
    },
    async handleDeleteFamilyMember(row) {
      if (!row.id) return;

      try {
        await delContactList({ id: row.id });
        await this.getList();
        this.$message.success("删除成功");
      } catch (err) {
        console.warn(err);
      }
    },
    async handleSubmit() {
      if (!this.form.name) {
        this.$message({
          message: '请输入姓名',
          type: "error"
        });
        return;
      }
      if (!this.form.gender) {
        this.$message({
          message: '请选择性别',
          type: "error"
        });
        return;
      }
      if (!this.form.idcard || this.form.idcard.length != 18) {
        this.$message({
          message: '请输入18位身份证号码',
          type: "error"
        });
        return;
      }
      if (!this.form.phone) {
        this.$message({
          message: '请输入联系方式',
          type: "error"
        });
        return;
      }
      if (!this.form.payWay) {
        this.$message({
          message: '请选择医疗费用支付方式',
          type: "error"
        });
        return;
      }
      if (!this.form.provinceCode) {
        this.$message({
          message: '请选择现住址-省',
          type: "error"
        });
        return;
      }

      if (!this.form.cityCode) {
        this.$message({
          message: '请选择现住址-市',
          type: "error"
        });
        return;
      }

      if (!this.form.countyCode) {
        this.$message({
          message: '请选择现住址-区',
          type: "error"
        });
        return;
      }

      if (!this.form.townCode) {
        this.$message({
          message: '请选择现住址-乡镇',
          type: "error"
        });
        return;
      }
      if (this.allergyDrugArr.length == 0) {
        this.$message({
          message: '请选择药物过敏史',
          type: "error"
        });
        return;
      } else {
        this.form.allergyDrug = this.allergyDrugArr.join(',');
      }
      if (this.diseases.length > 0) {
        var arr = this.diseases.filter(item => {
          return item.diseaseCode != null
        })
        var newArr = [];
        for (let i = 0; i < arr.length; i++) {
          var item = arr[i];
          var itemCode = item.diseaseCode;
          var option = this.diseasesData.filter(v => v.value == itemCode)[0];
          item.diseaseName = option.name;
          newArr.push(item);
        }
        this.form.diseases = newArr;
      }
      if (this.familyHistory.length > 0) {
        var arr = this.familyHistory.filter(item => {
          return item.diseaseCode != null
        })
        var newArr = [];
        for (let i = 0; i < arr.length; i++) {
          var item = arr[i];
          var itemCode = item.diseaseCode;
          var option = this.diseasesData.filter(v => v.value == itemCode)[0];
          item.diseaseName = option.name;

          if (item.familyRelationCode != null) {
            var relationCode = item.familyRelationCode;
            var optionRel = this.familyRelationData.filter(v => v.value == relationCode)[0];
            item.familyRelationName = optionRel.name;
          }
          newArr.push(item);
        }
        this.form.familyHistory = arr;
      }

      let birthday = this.form.idcard?.substr(6, 8);
      this.form.birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
      let params = Object.assign({}, this.form)
      updatePatientList(params).then(res => {
        if (res.msg == "success") {
          this.$message({
            message: "提交成功!",
            type: "success"
          })
          this.showDialog = false;
        }
      }).catch(err => {
        console.log(err);
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.personal-file-page {
  min-height: 100%;
  padding: 16px;
  background:
    radial-gradient(circle at top right, rgba(47, 111, 211, 0.08), transparent 20%),
    linear-gradient(180deg, #f4f7fb 0%, #eef2f8 100%);
}

.personal-file__shell {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 1440px;
  margin: 0 auto;
}

.hero-card {
  padding: 16px 20px;
  border: 1px solid #dbe7f6;
  border-radius: 6px;
  background: linear-gradient(135deg, #ffffff 0%, #f6faff 56%, #eef5ff 100%);
  box-shadow: 0 14px 28px rgba(18, 52, 92, 0.07);
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.hero-card__left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.hero-card__avatar {
  background: linear-gradient(135deg, #2f6fd3 0%, #5f96f4 100%);
  color: #fff;
  font-size: 22px;
  font-weight: 700;
  box-shadow: 0 8px 16px rgba(47, 111, 211, 0.2);
}

.hero-card__eyebrow {
  margin-bottom: 2px;
  color: #6682a6;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.08em;
}

.hero-card__title {
  margin: 0;
  color: #1b2a40;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.2;
}

.hero-card__info {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 6px;
}

.info-item--wide {
  grid-column: span 1;
}

.info-item__label {
  color: #7a8ca3;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
}

.info-item__value {
  color: #213248;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.4;
  word-break: break-all;
}

.hero-card__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.hero-card__tags ::v-deep .el-tag {
  height: 26px;
  line-height: 24px;
  padding: 0 10px;
  border-radius: 6px;
  font-size: 12px;
}

.section-card {
  overflow: hidden;
  border: none;
  border-radius: 8px;
  box-shadow: 0 14px 30px rgba(17, 38, 66, 0.06);
}

.multi-column-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.multi-column-grid .section-card {
  display: flex;
  flex-direction: column;
}

.multi-column-grid .section-card ::v-deep .el-card__body {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.blood-sugar-list {
  max-height: 320px;
  overflow: hidden;
}

.blood-sugar-scroll {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #edf1f7;
  border-radius: 6px;
  background: #fff;
}

.blood-sugar-scroll::-webkit-scrollbar {
  width: 6px;
}

.blood-sugar-scroll::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.blood-sugar-scroll::-webkit-scrollbar-thumb {
  background: #c1c9d4;
  border-radius: 3px;
}

.blood-sugar-scroll::-webkit-scrollbar-thumb:hover {
  background: #a0aab6;
}

.blood-sugar-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #edf1f7;
  transition: background 0.2s ease;
}

.blood-sugar-item:last-child {
  border-bottom: none;
}

.blood-sugar-item:hover {
  background: #f8fbff;
}

.blood-sugar-item__left {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.blood-sugar-label {
  color: #6b7b8d;
  font-size: 14px;
  font-weight: 600;
}

.blood-sugar-value {
  color: #1f2d3d;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.2;
}

.blood-sugar-item__time {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #8a97a8;
  font-size: 12px;
}

.blood-sugar-item__time i {
  font-size: 14px;
  color: #b0bec5;
}

.lab-exam-list {
  max-height: 320px;
  overflow: hidden;
}

.lab-exam-scroll {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #edf1f7;
  border-radius: 6px;
  background: #fff;
}

.lab-exam-scroll::-webkit-scrollbar {
  width: 6px;
}

.lab-exam-scroll::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.lab-exam-scroll::-webkit-scrollbar-thumb {
  background: #c1c9d4;
  border-radius: 3px;
}

.lab-exam-scroll::-webkit-scrollbar-thumb:hover {
  background: #a0aab6;
}

.lab-exam-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #edf1f7;
  transition: background 0.2s ease;
}

.lab-exam-item:last-child {
  border-bottom: none;
}

.lab-exam-item:hover {
  background: #f8fbff;
}

.lab-exam-item__left {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  min-width: 0;
}

.lab-exam-type-tag {
  flex-shrink: 0;
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
}

.tag-lab {
  background: #e8f4fd;
  color: #2469c9;
}

.tag-exam {
  background: #fef3e8;
  color: #d68c1f;
}

.lab-exam-name {
  color: #1f2d3d;
  font-size: 14px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.lab-exam-item__right {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.lab-exam-time {
  color: #8a97a8;
  font-size: 12px;
}

.section-card ::v-deep .el-card__header {
  padding: 18px 22px 16px;
  border-bottom: 1px solid #edf1f7;
}

.section-card ::v-deep .el-card__body {
  padding: 20px 22px 22px;
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.section-title-wrap {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.section-header__line {
  width: 20px;
  height: 16px;
  margin-top: 3px;
}

.section-title {
  color: #1f2d3d;
  font-size: 18px;
  font-weight: 700;
}

.section-desc {
  margin-top: 3px;
  color: #8a97a8;
  font-size: 13px;
}

.section-header__extra {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}

.member-count-badge {
  padding: 6px 10px;
  border-radius: 6px;
  background: #f2f8ff;
  color: #2469c9;
  font-size: 13px;
  font-weight: 700;
}

.file-form ::v-deep .el-form-item__label {
  padding-bottom: 6px;
  color: #4f5d6f;
  font-weight: 600;
  font-size: 13px;
}

.file-form ::v-deep .el-input__inner,
.file-form ::v-deep .el-select .el-input__inner,
.file-form ::v-deep .el-date-editor .el-input__inner,
.member-form ::v-deep .el-input__inner,
.member-form ::v-deep .el-select .el-input__inner {
  height: 36px;
  border-radius: 6px;
  border-color: #dce4ef;
}

.file-form ::v-deep .el-date-editor.el-input,
.member-form ::v-deep .el-date-editor.el-input {
  width: 100%;
}

.field {
  margin-bottom: 0;
}

.field--wide {
  grid-column: span 2;
}

.field--no-margin ::v-deep .el-form-item__content {
  line-height: 1.6;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px 16px;
}

.sub-block {
  margin-top: 16px;
  padding: 14px 16px 16px;
  border: 1px solid #edf1f7;
  border-radius: 6px;
  background: #fbfcfe;
}

.sub-block__title {
  margin-bottom: 10px;
  color: #334155;
  font-size: 15px;
  font-weight: 700;
}

.address-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
}

.choice-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.choice-grid ::v-deep .el-radio-group {
  display: inline-flex;
}

.choice-grid :deep(.el-radio-button__inner) {
  min-width: 66px;
  border-radius: 999px;
}

.history-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.history-card {
  padding: 18px;
  border: 1px solid #e8edf5;
  border-radius: 6px;
  background: linear-gradient(180deg, #ffffff 0%, #fbfcfe 100%);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8);
}

.history-card--wide {
  grid-column: 1 / -1;
}

.history-card--accent {
  background: linear-gradient(135deg, #f8fbff 0%, #eef5ff 100%);
  border-color: #d9e7fb;
}

.history-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 12px;
}

.history-card__header--start {
  align-items: flex-start;
}

.history-card__title {
  color: #263445;
  font-size: 16px;
  font-weight: 700;
}

.history-card__desc {
  margin-top: 4px;
  color: #8a97a8;
  font-size: 13px;
  line-height: 1.5;
}

.history-card__badge {
  flex-shrink: 0;
  padding: 6px 12px;
  border-radius: 6px;
  background: rgba(47, 111, 211, 0.12);
  color: #2f6fd3;
  font-size: 13px;
  font-weight: 700;
}

.history-card__action {
  flex-shrink: 0;
}

.checkbox-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.checkbox-wrap ::v-deep .el-checkbox {
  display: inline-flex;
  align-items: center;
  min-height: 36px;
  margin-right: 0;
  padding: 0 14px;
  border: 1px solid #dbe5f1;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.88);
  transition: all 0.2s ease;
}

.checkbox-wrap ::v-deep .el-checkbox:hover {
  border-color: #b9cff1;
}

.checkbox-wrap ::v-deep .el-checkbox__input {
  display: inline-flex;
}

.checkbox-wrap ::v-deep .el-checkbox__label {
  padding-left: 8px;
  color: #44556c;
  font-size: 13px;
}

.history-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.history-table-head {
  display: grid;
  grid-template-columns: 1fr 1fr auto;
  gap: 12px;
  padding: 0 14px 2px;
}

.history-table-head__cell {
  color: #52647b;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
}

.history-table-head__cell--action {
  text-align: right;
}

.history-entry {
  padding: 14px;
  border: 1px solid #edf1f7;
  border-radius: 6px;
  background: #fff;
}

.history-entry__form {
  display: grid;
  grid-template-columns: 1fr 1fr auto;
  gap: 12px;
  align-items: end;
}

.history-entry__field {
  margin-bottom: 0;
}

.history-entry__field--action {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}

.history-entry__field ::v-deep .el-select,
.history-entry__field ::v-deep .el-date-editor.el-input {
  width: 100%;
}

.history-entry__remove {
  min-width: 72px;
}

.history-empty {
  padding: 16px 14px;
  border: 1px dashed #d7e1ec;
  border-radius: 6px;
  background: rgba(248, 251, 255, 0.7);
  color: #7d8a9a;
  font-size: 13px;
  text-align: center;
}

.table-card__summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
  padding: 12px 16px;
  border: 1px solid #e8f1fb;
  border-radius: 6px;
  background: #f8fbff;
  color: #5c6b7d;
  font-size: 13px;
}

.table-scroll {
  overflow-x: auto;
}

.member-table ::v-deep .el-table__header-wrapper th {
  background: #f7f9fc;
  color: #4c5a6a;
  font-size: 14px;
}

.member-table ::v-deep .el-table__body-wrapper td {
  font-size: 14px;
}

.member-name-cell {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
}

.member-avatar {
  flex-shrink: 0;
  background: linear-gradient(135deg, #2f6fd3 0%, #4c90f5 100%);
  color: #fff;
  font-weight: 700;
  font-size: 14px;
}

.relation-tag {
  border-radius: 6px;
}

.danger-text {
  margin-left: 10px;
  color: #f56c6c;
}

.drug-count-badge {
  padding: 6px 10px;
  border-radius: 6px;
  background: #f2f8ff;
  color: #2469c9;
  font-size: 13px;
  font-weight: 700;
}

.drug-usage-list {
  max-height: 320px;
  overflow: hidden;
}

.drug-list-scroll {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #edf1f7;
  border-radius: 6px;
  background: #fff;
}

.drug-list-scroll::-webkit-scrollbar {
  width: 6px;
}

.drug-list-scroll::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.drug-list-scroll::-webkit-scrollbar-thumb {
  background: #c1c9d4;
  border-radius: 3px;
}

.drug-list-scroll::-webkit-scrollbar-thumb:hover {
  background: #a0aab6;
}

.drug-item {
  padding: 14px 16px;
  border-bottom: 1px solid #edf1f7;
  transition: background 0.2s ease;
}

.drug-item:last-child {
  border-bottom: none;
}

.drug-item:hover {
  background: #f8fbff;
}

.drug-item__name {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  color: #1f2d3d;
  font-size: 14px;
  font-weight: 600;
}

.drug-item__icon {
  color: #2f6fd3;
  font-size: 16px;
}

.drug-item__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 6px;
}

.drug-meta-item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #5c6b7d;
  font-size: 12px;
}

.drug-meta-item i {
  color: #8a97a8;
  font-size: 13px;
}

.drug-item__time {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #8a97a8;
  font-size: 12px;
}

.drug-item__time i {
  font-size: 13px;
}

.drug-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  border: 1px dashed #d7e1ec;
  border-radius: 6px;
  background: rgba(248, 251, 255, 0.7);
  color: #7d8a9a;
  font-size: 14px;
}

.drug-empty i {
  margin-bottom: 8px;
  font-size: 32px;
  color: #b0bec5;
}

.pagination-bar {
  margin-top: 16px;
}

.action-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 16px 20px;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 14px 30px rgba(17, 38, 66, 0.06);
}

.action-bar__hint {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #7a889a;
  font-size: 13px;
}

.member-form__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.member-dialog ::v-deep .el-dialog {
  overflow: hidden;
  border-radius: 8px;
}

.member-dialog ::v-deep .el-dialog__header {
  padding: 18px 22px 14px;
  border-bottom: 1px solid #edf1f7;
}

.member-dialog ::v-deep .el-dialog__title {
  color: #1e2a3a;
  font-size: 18px;
  font-weight: 700;
}

.member-dialog ::v-deep .el-dialog__body {
  padding: 16px 22px 12px;
}

.member-dialog ::v-deep .el-dialog__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 14px 22px 18px;
  border-top: 1px solid #edf1f7;
  background: #fbfcfe;
}

.member-dialog__tip {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 16px;
  padding: 12px 14px;
  border: 1px solid #e4edf9;
  border-radius: 6px;
  background: #f5f9ff;
}

.member-dialog__tip>i {
  margin-top: 1px;
  color: #2f6fd3;
  font-size: 18px;
}

.member-dialog__tip-title {
  color: #1f2d3d;
  font-size: 14px;
  font-weight: 700;
}

.member-dialog__tip-desc {
  margin-top: 2px;
  color: #6f7f92;
  font-size: 13px;
  line-height: 1.5;
}

.member-dialog__footer-hint {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #7d8a9a;
  font-size: 12px;
}

.member-dialog__footer-hint i {
  color: #2f6fd3;
  font-size: 14px;
}

@media (max-width: 1200px) {
  .hero-card__info {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .multi-column-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 992px) {

  .multi-column-grid {
    grid-template-columns: 1fr;
  }

  .section-header,
  .table-card__summary,
  .action-bar {
    flex-direction: column;
    align-items: flex-start;
  }

  .section-header__extra {
    width: 100%;
    justify-content: space-between;
  }

  .history-grid,
  .member-form__grid {
    grid-template-columns: 1fr;
  }

  .history-entry__form {
    grid-template-columns: 1fr;
  }

  .history-table-head {
    display: none;
  }

  .history-entry__field--action {
    justify-content: flex-start;
  }

  .member-dialog ::v-deep .el-dialog__footer {
    flex-direction: column;
    align-items: flex-start;
  }

  .field--wide,
  .info-item--wide {
    grid-column: span 1;
  }
}

@media (max-width: 768px) {
  .personal-file-page {
    padding: 12px;
  }

  .hero-card,
  .section-card ::v-deep .el-card__header,
  .section-card ::v-deep .el-card__body,
  .action-bar {
    padding-left: 16px;
    padding-right: 16px;
  }

  .hero-card__left {
    flex-direction: column;
    align-items: flex-start;
  }

  .hero-card__info,
  .form-grid,
  .address-grid,
  .choice-grid {
    grid-template-columns: 1fr;
  }

  .history-card,
  .history-entry {
    padding: 16px;
  }

  .history-card__header {
    flex-direction: column;
    align-items: flex-start;
  }

  .section-header__extra {
    align-items: stretch;
  }
}
</style>
